import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const pairCigarAssignmentsApi = {
  list: async (params: { startDate?: string; endDate?: string; taskIds?: string[] }) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/pair-cigar-assignments/v1`, {
        params,
      });

      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  getProductionPrediction: async (params: { pairId: string; cigarId: string; limit?: number }) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/pair-cigar-assignments/v1/production-prediction`, {
        params,
      });

      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  getActualProduction: async (params: { startDate: string; endDate: string }) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/pair-cigar-assignments/v1/actual-production`, {
        params,
      });

      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  getPlanProductionActuals: async (params: { planIds: string[] }) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/pair-cigar-assignments/v1/plan-production-actuals`, {
        params: {
          ...params,
          planIds: params.planIds.join(','),
        },
      });

      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  create: async (data: {
    pairId: string;
    cigarId: string;
    startDate: string;
    endDate: string;
    quantity: number;
    totalQuantity?: number;
    ignoreSaturday?: boolean;
    ignoreSunday?: boolean;
    taskId?: string | null;
  }) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/pair-cigar-assignments/v1`, data);

      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  update: async (
    id: string,
    data: {
      pairId: string;
      cigarId: string;
      startDate: string;
      endDate: string;
      quantity: number;
      totalQuantity?: number;
      ignoreSaturday?: boolean;
      ignoreSunday?: boolean;
      taskId?: string | null;
    }
  ) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/pair-cigar-assignments/v1/${id}`, data);

      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  delete: async (id: string) => {
    try {
      const res = await axiosApiInstance.delete(`${apiRoot}/pair-cigar-assignments/v1/${id}`);

      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  split: async (id: string, data: { splitQuantity: number }) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/pair-cigar-assignments/v1/${id}/split`, data);

      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  getAttributionDebug: async (params: { startDate?: string; endDate?: string }) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/pair-cigar-assignments/v1/attribution-debug`, {
        params,
      });

      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  recalculateCigarAttribution: async (cigarId: string) => {
    try {
      const res = await axiosApiInstance.post(
        `${apiRoot}/pair-cigar-assignments/v1/recalculate-cigar-attribution`,
        null,
        {
          params: { cigarId },
        }
      );

      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default pairCigarAssignmentsApi;
